var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout--full-page"},[(_vm.$route.meta.pageTitle)?_c('h4',{staticClass:"mt-2 pr-2 pl-2",domProps:{"textContent":_vm._s(_vm.$t(_vm.$route.meta.pageTitle))}}):_vm._e(),(_vm.$route.meta.pageTitle)?_c('vs-divider',{staticClass:"mt-2 mb-2"}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }